import React, { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { ErrorMessage, FieldArray } from "formik";
import CheckboxInput from "src/components/UI/CheckboxInput";
import TooltipMEL from "src/components/UI/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePendingCommand,
  getPendingReasonAllLoading,
  getPendingReasonLoading,
} from "src/store/actions";
import { RootReducerState } from "src/store/reducers";
import { useParams, useLocation } from "react-router";
import {
  ConvertIsoStringWithTime,
  formatDateTimeFormServerView,
  hasAdminOrEmployeeRoleHandler,
} from "src/helpers/common_helpers";
import TextEditor from "src/components/atoms/TextEditor";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import FeatherIcon from "feather-icons-react";
import ErrorText from "../ErrorText";
import { Mention } from "primereact/mention";
import { set } from "lodash";
import GroupChat from "../../../pages/JobSheets/JobSheets/chat/GroupChat";
import { API } from "src/util/api";

interface TabProps {
  activeTab: string | number;
  status: string;
  initialValues: any;
  touch: any;
  error: any;
  handleChange?: any;
  onBlur?: () => void;
  changeFlow: any;
  setFieldError: any;
  setFieldTouched: any;
  setFieldValue: any;
  jobId?: any;
}

const PendingComments = (props: TabProps) => {
  const dispatch = useDispatch();
  const lastSentCommentRef = useRef<{ pendingReasonId: any; pendingInformation: any } | null>(null);
  const { pendingReason, jobsheet, pendingReasonAll } = useSelector(
    (state: RootReducerState) => state.jobsheetReducer
  );
  const { profile } = useSelector(
    (state: RootReducerState) => state.profilesReducer
  );
  const [canAllowPending, setCanAllowPending] = useState<boolean | null>(null);
  const pendingreasonDropdown = useMemo(() => {
    let reasons = pendingReason || [];
    if (canAllowPending === false) {
      reasons = reasons.filter((reason: any) => reason.name === "Confirmation received from Dealer");
    }
    return reasons?.length > 0
      ? reasons
        .map((reason: any) => {
          let data: any = {};
          data["value"] = reason.id;
          data["label"] = reason.name;
          return data;
        })
        .sort((a: any, b: any) => {
          const labelA = a.label.toUpperCase().trim();
          const labelB = b.label.toUpperCase().trim();
          if (labelA < labelB) {
            return -1;
          }
          if (labelA > labelB) {
            return 1;
          }
          return 0;
        })
      : [];
  }, [pendingReason, canAllowPending]);

  const location = useLocation();

  useEffect(() => {
    const fetchCanAllowPending = async () => {
      if (props.jobId) {
        try {
          const response = await API.canAllowPendingApi(props.jobId);
          setCanAllowPending(response.data);
        } catch (error) {
          console.error("Error fetching canAllowPending", error);
        }
      }
    };
    if (props.activeTab === "Present Status") {
      dispatch(getPendingReasonLoading());
      dispatch(getPendingReasonAllLoading());
      fetchCanAllowPending();
    }
  }, [props.activeTab, props.jobId, location]);

  const handleSelect = (label: string, value: string) => {
    setSelectedReason({ value: value, label: label });
  };

  const [messages, setMessages] = useState<any>([]);
  const [newMessage, setNewMessage] = useState("");
  const messagesEndRef: any = useRef(null);
  const groupMessagesByDate = (messages: any[]) => {
    return messages.reduce((groups: any, message: any) => {
      const date = new Date(message.timestamp).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      if (!groups[date]) groups[date] = [];
      groups[date].push(message);
      return groups;
    }, {});
  };

  const groupedMessages = useMemo(
    () => groupMessagesByDate(messages),
    [messages]
  );

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const rightUser = Array.isArray(authUser.role)
    ? authUser.role[0]
    : [authUser.role];
  const [selectedReason, setSelectedReason] = useState<any>({
    value: "",
    label: "",
  });

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    setMessages((prevMessages: any) => [
      ...prevMessages,
      {
        id: Date.now(),
        text: newMessage,
        pendingReason: selectedReason.label,
        sender: Array.isArray(authUser.role) ? authUser.role[0] : authUser.role,
        name: profile?.name || "Admin",
        timestamp: new Date(),
      },
    ]);
    setNewMessage("");
    setSelectedReason({ value: "", label: "" });
  };

  const [filteredUsers, setFilteredUsers] = useState<any>([]);
  const users = [
    { nickname: "Ajay" },
    { nickname: "Suresh" },
    { nickname: "Priya" },
    { nickname: "Admin" },
  ];

  const searchUsers = (event: any) => {
    setTimeout(() => {
      const query = event.query.toLowerCase();
      const results = query
        ? users.filter((user) => user.nickname.toLowerCase().startsWith(query))
        : [...users];
      setFilteredUsers(results);
    }, 100);
  };
  console.log("123", props.initialValues.inPending);

  return (
    <div
      className={`job-sheet-tab-content  ${props.activeTab === "Present Status" ? "" : "d-none"
        }`}
    >
      <Card className="pe-0 ps-0 mb-0 border-leftrigh-none">
        <div className="dealer-title-header font-size-15 border-bottom">
          Pending Information
        </div>

        <CardBody className="p-0 pending-comments-cardbody">
          <div className="px-3 pb-3">
            <Row>
              <Col lg={3} className="d-flex align-items-center">
                {/* <CheckboxInput
                  name="inPending"
                  label="Mark Job as Pending"
                  value={props.initialValues.inPending}
                  onChange={
                    (e:any)=>{
                      props.handleChange(e);
                      props.initialValues.inPending =  e.target.checked;
                      props.changeFlow(props.initialValues, props.initialValues?.status,  props.setFieldError, props.setFieldTouched, props.setFieldValue)
                    }
                    }
                /> */}
                <FieldArray name="pendingCommentsDto">
                  {({ push }) => (
                    <div>
                      <CheckboxInput
                        name="inPending"
                        label="Mark Job as Pending"
                        value={props.initialValues.inPending}
                        onChange={(e) => {
                          props.handleChange(e);
                          props.initialValues.inPending = e.target.checked;
                          if (!props.initialValues.isOldPending) {
                            if (e.target.checked) {
                              props.initialValues.recentInPending = true;
                            } else {
                              props.initialValues.recentInPending = false;
                            }
                          }
                          if (!e.target.checked) {
                            if (props.initialValues.pendingCommentsDtoNew?.length > 0) {
                              if (props.initialValues.pendingCommentsDtoNew[0].pendingReasonId || props.initialValues.pendingCommentsDtoNew[0].pendingInformation) {
                                lastSentCommentRef.current = {
                                  pendingReasonId: props.initialValues.pendingCommentsDtoNew[0].pendingReasonId,
                                  pendingInformation: props.initialValues.pendingCommentsDtoNew[0].pendingInformation
                                };
                              }
                              props.setFieldValue('pendingCommentsDtoNew[0].pendingReasonId', "");
                              props.setFieldValue('pendingCommentsDtoNew[0].pendingInformation', "");
                            }
                          } else {
                            if (lastSentCommentRef.current) {
                              props.setFieldValue('pendingCommentsDtoNew[0].pendingReasonId', lastSentCommentRef.current.pendingReasonId);
                              props.setFieldValue('pendingCommentsDtoNew[0].pendingInformation', lastSentCommentRef.current.pendingInformation);
                            }
                          }
                          // if (e.target.checked) {
                          //   handleAddPendingCommentsNew(push,"add");
                          // }else{
                          //   handleAddPendingCommentsNew(push,"remove");
                          // }
                          props.changeFlow(
                            props.initialValues,
                            props.initialValues?.status,
                            props.setFieldError,
                            props.setFieldTouched,
                            props.setFieldValue
                          );
                        }}
                      />
                      <ErrorMessage name={"inPending"} component={ErrorText} />
                    </div>
                  )}
                </FieldArray>
              </Col>
            </Row>

            <Row>
              <div>
                <Row className="mt-2">
                  {/* <FieldArray name="pendingCommentsDtoNew">
                {({ insert, remove, push }) => (
                  <div >
                    <Row className='mt-2'>
                      <div className='dealer-title-header font-size-15 border-bottom'>
                        <span className='pull-left'>Job Sheet Present Status</span>
                      </div>
                    </Row>
                    {props.initialValues.pendingCommentsDtoNew?.length > 0 &&
                      props.initialValues.pendingCommentsDtoNew.map(
                        (value: any, index: any) => {
                          return <div key={index}>
                            <Row>
                              <Col lg={5} md={7} sm={12} className="mt-mb">
                                <FloatInput
                                  type="dropdown"
                                  name={`pendingCommentsDtoNew[${index}].pendingReasonId`}
                                  label="Pending reason"
                                  disabled={false}
                                  onChange={props.handleChange}
                                  onBlur={props.onBlur}
                                  required={true}
                                  value={value.pendingReasonId}
                                  options={pendingreasonDropdown}
                                  invalid={props.touch.pendingCommentsDtoNew?.[index]?.pendingReasonId && props.error.pendingCommentsDtoNew?.[index]?.pendingReasonId ? true : false}
                                />
                              </Col>
                              {/* <Col lg={4} className="mt-mb-textarea">
                                <div className="d-flex align-items-start">
                                  <div className="d-block w-100">
                                  
                                    <TextEditor
                                      onChange={props.handleChange}
                                      labelName='Pending information'
                                      name={`pendingCommentsDtoNew[${index}].pendingInformation`}
                                      required={true}
                                      value={value.pendingInformation}
                                      invalid={props.touch.pendingCommentsDtoNew?.[index]?.pendingInformation && props.error.pendingCommentsDtoNew?.[index]?.pendingInformation ? true : false}
                                      setFieldTouched={props.setFieldTouched}
                                      setFieldValue={props.setFieldValue}
                                      onBlur={props.onBlur}
                                      readOnly={false}
                                    />
                                  </div>
                                </div>
                              </Col> 
                            </Row>
                          </div>;
                        }
                      )}
                  </div>

                )}
              </FieldArray>*/}
                  {/* {props.initialValues.pendingCommentsDto.length>0 ?
                <div className="card ps-0 pe-0 mt-2" id="table-border">
                  <DataTable size='large' value={props.initialValues.pendingCommentsDto} showGridlines tableStyle={{ minWidth: '50rem', padding: "30px" }}>
                    <Column field="pendingReasonId" header="Pending reason" className='' body={ (rowData) => findPendingLabel(rowData.pendingReasonId)}></Column>
                    <Column field="pendingInformation" header="Pending Information" className=''  body={ (rowData) => htmlHandler(rowData.pendingInformation)}></Column>
                    <Column field="commentedAt" header="Commented At" className=''  body={ (rowData) => formatDateTimeFormServerView(rowData.commentedAt)}></Column>
                  </DataTable>
                </div>
                : null } */}

                  {/* new */}
                  {/* <div className="chat-page">
                    {hasAdminOrEmployeeRoleHandler() &&
                          <div className="pending-commands">
                            <b>You can select here for Chat!!!</b>
                            <div className="pending-reason">
                              {pendingreasonDropdown?.map((reason:any)=>{
                                return(
                                  <span key={reason.value} className="pending-chip" onClick={()=>handleSelect(reason.label,reason.value)}>{reason.label}</span>
                                )
                              })}
                              </div>
                          </div>
                  }
                    <div className={`chat-body  job`}>
                    {Object.entries(groupedMessages || {}).map(([date, msgs]: any) => (
                      <div key={date}>
                        {/* Date Header */}
                  {/* <div className="chat-date-divider">
                          <span className='chat-date'>{date}</span>
                        </div> */}

                  {/* Messages for this date */}
                  {/* {msgs?.map((msg:any) => {
                          const formattedTime = new Date(msg.timestamp).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                          });
                          return (
                            <div key={msg.id}>
                              <span
                                className={`chat-info ${
                                  rightUser.includes(msg.sender) ? "right" : "left"
                                }`}
                              >
                                {msg.name} <span className="chat-time">{formattedTime}</span>
                              </span>
                              <div
                                className={`chat-message ${
                                  rightUser.includes(msg.sender) ? "right" : "left"
                                }`}
                              >
                                <div className="bubble">
                                  <div className='pending-reason-title'>{msg.pendingReason}</div>
                                  {msg.text}
                                  </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                    <div ref={messagesEndRef} />
                  </div>
                  <hr />
                      {selectedReason.label != "" &&
                        <div className='selected-reason'>
                          <b>Selected Reason: </b> {selectedReason.label} <div className="icon"><FeatherIcon icon={"x"} className="" onClick={()=>setSelectedReason({value:"",label:""})}/></div>
                        </div>
                      }
                     <form className="chat-input" onSubmit={handleSend}>
                      <div className='w-100'>
                            <Mention
                              trigger="@"
                              suggestions={filteredUsers}
                              field="nickname"
                              onSearch={searchUsers}
                              value={newMessage}
                              onChange={(e:any) => setNewMessage(e.target.value)}
                              placeholder="Type a message and use @ to mention..."
                              rows={2}
                              style={{ width: '100%' }}
                              panelStyle={{ width: '180px' }}
                            />
                            </div>
                            <button type="button" onClick={handleSend}><FeatherIcon icon={"send"}/></button>
                          </form>
                </div> */}
                  {/* new  chat module Ui design (10-10-25)*/}
                  <GroupChat pendingreasonDropdown={pendingreasonDropdown} valuesProp={props.initialValues} setFieldValue={props.setFieldValue} pending={jobsheet?.inPending} />
                </Row>
              </div>
            </Row>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default PendingComments;
